import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { DEVICE_LIST } from "@/data/devices";

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export default function GeraeteOverviewPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="geraete-overview-page">
      {/* Hero */}
      <section className="bg-zinc-50 py-16 border-b border-zinc-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeUp}
            transition={{ duration: 0.5 }}
          >
            <p className="text-sm text-orange-600 font-medium mb-2">Geräte mieten</p>
            <h1 className="text-3xl sm:text-4xl font-bold text-zinc-950 tracking-tight mb-4">
              Geräte & Maschinen
            </h1>
            <p className="text-lg text-zinc-600 max-w-2xl">
              Neben dem PKW-Anhänger vermieten wir praktische Geräte für Boden und Wand –
              Preise auf Anfrage, Paket-Rabatt bei Kombi-Miete mit dem Anhänger möglich.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Device Grid */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {DEVICE_LIST.map((device, idx) => (
              <motion.div
                key={device.slug}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
              >
                <Link
                  to={`/geraete/${device.slug}`}
                  data-testid={`device-card-${device.slug}`}
                  className="group block rounded-2xl overflow-hidden border border-zinc-200 bg-white hover:shadow-xl hover:border-orange-200 transition-all duration-300"
                >
                  <div className="aspect-[4/3] bg-zinc-50 overflow-hidden flex items-center justify-center p-6">
                    <img
                      src={device.image}
                      alt={device.shortTitle}
                      className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <h2 className="text-xl font-bold text-zinc-950 mb-2">{device.shortTitle}</h2>
                    <p className="text-sm text-zinc-600 leading-relaxed mb-4 line-clamp-2">
                      {device.subline}
                    </p>
                    <span className="inline-flex items-center gap-2 text-sm font-medium text-orange-600 group-hover:gap-3 transition-all">
                      Jetzt Verfügbarkeit prüfen
                      <ArrowRight className="h-4 w-4" />
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
